import { Component, OnInit, Inject } from '@angular/core';
import * as _ from 'lodash';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { AttachmentModel } from '../../models/attachmentModel';
import { AttachmentTypeModel } from '../../models/attachment-type.model';
import { Restangular } from 'ngx-restangular';
import { APP_BRAND } from '@app/common/services/config.service';
import { AttachmentTypeCategoryEnum } from '@app/sv/enums/attachment-type-category.enum';

@Component({
  selector: 'attachment-edit-form',
  templateUrl: './attachment-edit-form.component.html',
})
export class AttachmentEditFormComponent implements OnInit {

  // model
  loading: boolean;
  allowType: boolean;
  omitFileUpload: boolean;
  attachment: AttachmentModel;
  attachmentTypes: AttachmentTypeModel[];
  activeAttachmentType: AttachmentTypeModel;
  initialAttachmentType: AttachmentTypeModel;

  constructor(
      @Inject(APP_BRAND) public APP_BRAND: any,
      private restangular: Restangular,
      private dialogConfig: DialogConfig,
      public dialogComponent: DialogRef,
  ) {
    this.onUpdate = this.onUpdate.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  ngOnInit() {
    const data = this.dialogConfig.data as DialogConfigData;
    const attachmentCategory = data.attachmentCategory;
    this.allowType = data.allowType;
    this.omitFileUpload = !!data.omitFileUpload;
    this.attachment = data.attachment;
    this.initialAttachmentType = AttachmentTypeModel.createById(this.attachment.type);
    this.activeAttachmentType = _.cloneDeep(this.initialAttachmentType);
    this.attachmentTypes = _.cloneDeep(AttachmentTypeModel.getByCategory(attachmentCategory));
    if (this.APP_BRAND.NAME === 'RSD') {
      _.remove(this.attachmentTypes, (i) => i.id === 'INFORMATION_LETTER');
      _.remove(this.attachmentTypes, (i) => i.id === 'ENTRY_PROPOSAL');
      _.remove(this.attachmentTypes, (i) => i.id === 'ENTRY_PROPOSAL_NOTIFICATION');
    }

    // check disabled types
    for (const disabledAttachmentType of (data.disabledAttachmentTypes || [])) {
      const found = this.attachmentTypes.find(dt => dt.id === disabledAttachmentType.attachmentType);
      if (found) {
        found.disabled = disabledAttachmentType.reason;
      }
    }
  }

  onUpdateType(attachmentType: AttachmentTypeModel) {
    this.attachment.type = attachmentType.id;
    this.activeAttachmentType = attachmentType;
  }

  onUpdate() {
    if (!this.omitFileUpload) {
      this.loading = true;
      const restAttachment = this.restangular.restangularizeElement(null, this.attachment, `attachments`);

      return restAttachment.put().toPromise().then(data => {
        this.loading = false;
        this.dialogComponent.close(data.plain());
      });
    } else {
      this.dialogComponent.close(this.attachment);
    }
  }

  onCancel() {
    this.dialogComponent.close(false);
  }

  isValid() {
    return this.attachment.baseName && this.attachment.type && (!this.activeAttachmentType.extensions || this.activeAttachmentType.extensions.includes(this.attachment.extension));
  }
}
